import { Fragment } from 'react';
import { Typography } from '@mui/material';
import { Campaign } from '../../types/Campaign';
import { CapitalizeTypography } from '../../pages/campaign/partials/CampaignWizard/CampaignWizardStyles';
import Column from '../../components/Column';
import Utils from '../../components/Utils';

export interface CampaignFrequencySummaryProps {
    campaign: Campaign;
}

export default function CampaignFrequencySummary(props: CampaignFrequencySummaryProps) {
    const { campaign } = props;

    return (
        <Column gap={0}>
            {campaign.frequencyType === 'CUSTOM' ? (
                <Fragment>
                    Frequency cap
                    <Typography variant="caption" color="text.secondary">
                        Show no more than {campaign.frequencyMaxImpressions} times per {campaign.frequencyTimeUnitCount}{' '}
                        {campaign?.frequencyTimeUnit?.toLowerCase()}
                    </Typography>
                </Fragment>
            ) : (
                <Typography variant="caption" color="text.secondary">
                    <CapitalizeTypography>{Utils.convertCase(campaign.budgetCapType)}</CapitalizeTypography>
                </Typography>
            )}
        </Column>
    );
}
